export default __webpack_public_path__ + "static/media/floor-sweeping.e8a7d9b3.jpg";